import { Stack, styled } from '@mui/material';
import { VssPlan } from '@portal-middleware/hooks';
import { Link, ScreenReaderOnlyText, Text } from '@vestwell-frontend/ui';

import { FC } from 'react';

export type NeedHelpPhoneNumberProps = {
  plan: VssPlan;
};

const UnderlinedLink = styled(Link)(() => ({
  textDecoration: 'underline'
}));

export const NeedHelpPhoneNumber: FC<NeedHelpPhoneNumberProps> = props => {
  return (
    <Stack mt={6}>
      <Text color='grey300' mb={2} variant='j2'>
        <strong>Need help? </strong>
        Call Us {props.plan?.supportPhone} or {props.plan?.supportTty}
      </Text>
      <Text color='grey300' mb={0} variant='j2'>
        <strong>Contributing via check? </strong>
        Fill out this{' '}
        <UnderlinedLink target='_blank' to={props.plan?.urls?.giftingForm}>
          Gift Form
          <ScreenReaderOnlyText> (opens in new tab)</ScreenReaderOnlyText>
        </UnderlinedLink>{' '}
        and follow the mailing instructions.
      </Text>
    </Stack>
  );
};
